/**
 * Contact Form Fragment
 *
 * Common pattern for contact form references used in blocks.
 */

/**
 * Field projection for a contact form reference
 * Can be interpolated into block queries
 */
export const contactFormFields = `
  _type,
  title,
  ctaTitle,
  formTitle,
  formSubTitle,
  pipelineId,
  successHeading,
  successMessage
`
